import React, { FC } from "react";
import { Loading } from "components";

interface IProp {
  isLoading?: boolean;
  children: any;
}

export const LoadingWrapper: FC<IProp> = ({ isLoading, children }) => <>{isLoading ? <Loading /> : children}</>;
